"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TEXT_COLOR_DISABLED = exports.TEXT_COLOR = exports.SHADOW_OPACITY = exports.SHADOW_COLOR = exports.SCREEN_EDGE_GAP = exports.NAVIGATION_SELECTED_COLOR = exports.NAVIGATION_HIGHLIGHT_COLOR = exports.MINIMAL_HEIGHT = exports.MAX_VISIBLE_ITEMS = exports.LABEL_TEXT_COLOR = exports.ITEM_WITH_GROUPING_LEFT_PADDING = exports.ITEM_PADDING = exports.HIGHLIGHT_TEXT_COLOR = exports.HIGHLIGHT_COLOR = exports.FONT_SIZE = exports.DIVIDER_WIDTH = exports.DIVIDER_COLOR = exports.CHEVRON_COLOR_WARNING = exports.CHEVRON_COLOR_ERROR = exports.CHEVRON_COLOR_DISABLED = exports.CHEVRON_COLOR = exports.BORDER_WIDTH = exports.BORDER_COLOR_WARNING_HOVER = exports.BORDER_COLOR_WARNING_FOCUS = exports.BORDER_COLOR_WARNING = exports.BORDER_COLOR_HOVER = exports.BORDER_COLOR_FOCUS = exports.BORDER_COLOR_ERROR_HOVER = exports.BORDER_COLOR_ERROR_FOCUS = exports.BORDER_COLOR_ERROR = exports.BORDER_COLOR = exports.BACKGROUND_COLOR_DISABLED = void 0;
var BORDER_WIDTH = 2;
exports.BORDER_WIDTH = BORDER_WIDTH;
var BORDER_COLOR = 'neutral50';
exports.BORDER_COLOR = BORDER_COLOR;
var BORDER_COLOR_HOVER = 'primary60';
exports.BORDER_COLOR_HOVER = BORDER_COLOR_HOVER;
var BORDER_COLOR_FOCUS = 'primary80';
exports.BORDER_COLOR_FOCUS = BORDER_COLOR_FOCUS;
var BORDER_COLOR_ERROR = 'red70';
exports.BORDER_COLOR_ERROR = BORDER_COLOR_ERROR;
var BORDER_COLOR_ERROR_HOVER = 'red60';
exports.BORDER_COLOR_ERROR_HOVER = BORDER_COLOR_ERROR_HOVER;
var BORDER_COLOR_ERROR_FOCUS = 'red80';
exports.BORDER_COLOR_ERROR_FOCUS = BORDER_COLOR_ERROR_FOCUS;
var BORDER_COLOR_WARNING = 'yellow70';
exports.BORDER_COLOR_WARNING = BORDER_COLOR_WARNING;
var BORDER_COLOR_WARNING_HOVER = 'yellow60';
exports.BORDER_COLOR_WARNING_HOVER = BORDER_COLOR_WARNING_HOVER;
var BORDER_COLOR_WARNING_FOCUS = 'yellow80';
exports.BORDER_COLOR_WARNING_FOCUS = BORDER_COLOR_WARNING_FOCUS;
var SHADOW_COLOR = 'neutral90';
exports.SHADOW_COLOR = SHADOW_COLOR;
var SHADOW_OPACITY = 0.3;
exports.SHADOW_OPACITY = SHADOW_OPACITY;
var DIVIDER_WIDTH = 1;
exports.DIVIDER_WIDTH = DIVIDER_WIDTH;
var DIVIDER_COLOR = 'neutral30';
exports.DIVIDER_COLOR = DIVIDER_COLOR;
var ITEM_PADDING = 'S200';
exports.ITEM_PADDING = ITEM_PADDING;
var ITEM_WITH_GROUPING_LEFT_PADDING = 'S300';
exports.ITEM_WITH_GROUPING_LEFT_PADDING = ITEM_WITH_GROUPING_LEFT_PADDING;
var SCREEN_EDGE_GAP = 'S300';
exports.SCREEN_EDGE_GAP = SCREEN_EDGE_GAP;
var FONT_SIZE = 'T200';
exports.FONT_SIZE = FONT_SIZE;
var TEXT_COLOR = 'neutral90';
exports.TEXT_COLOR = TEXT_COLOR;
var TEXT_COLOR_DISABLED = 'neutral70';
exports.TEXT_COLOR_DISABLED = TEXT_COLOR_DISABLED;
var LABEL_TEXT_COLOR = 'neutral70';
exports.LABEL_TEXT_COLOR = LABEL_TEXT_COLOR;
var CHEVRON_COLOR = 'primary70';
exports.CHEVRON_COLOR = CHEVRON_COLOR;
var CHEVRON_COLOR_ERROR = 'red70';
exports.CHEVRON_COLOR_ERROR = CHEVRON_COLOR_ERROR;
var CHEVRON_COLOR_WARNING = 'yellow70';
exports.CHEVRON_COLOR_WARNING = CHEVRON_COLOR_WARNING;
var CHEVRON_COLOR_DISABLED = 'neutral70';
exports.CHEVRON_COLOR_DISABLED = CHEVRON_COLOR_DISABLED;
var BACKGROUND_COLOR_DISABLED = 'neutral10';
exports.BACKGROUND_COLOR_DISABLED = BACKGROUND_COLOR_DISABLED;
var HIGHLIGHT_COLOR = 'primary05';
exports.HIGHLIGHT_COLOR = HIGHLIGHT_COLOR;
var HIGHLIGHT_TEXT_COLOR = 'neutral0';
exports.HIGHLIGHT_TEXT_COLOR = HIGHLIGHT_TEXT_COLOR;
var NAVIGATION_SELECTED_COLOR = 'primary70';
exports.NAVIGATION_SELECTED_COLOR = NAVIGATION_SELECTED_COLOR;
var NAVIGATION_HIGHLIGHT_COLOR = 'primary60';
exports.NAVIGATION_HIGHLIGHT_COLOR = NAVIGATION_HIGHLIGHT_COLOR;
var MINIMAL_HEIGHT = 150;
exports.MINIMAL_HEIGHT = MINIMAL_HEIGHT;
var MAX_VISIBLE_ITEMS = 10;
exports.MAX_VISIBLE_ITEMS = MAX_VISIBLE_ITEMS;